<template>
	<section class="relativeclass">
		<label>{{ labelTxt }}<span class="asterik">*</span></label>
		<span class="text-style"> (This is the README File to this project)</span>
		<mavon-editor
			:class="{ error: validation }"
			class="mt-2 mavon-editor-custom"
			v-model="content"
			:toolbars="toolbarOptions"
			language="en"
			@input="onInput"
		/>
		<div
			style="position: absolute; bottom: 5px; right: 12px"
			v-if="validation"
			v-b-popover.hover.top.v-danger="{ content: 'Required' }"
			variant="primary"
		>
			<img src="../../assets/deletepopupicon.svg" alt="" />
		</div>
	</section>
</template>

<script>
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
	name: "CustomQuillEditor",
	props: {
		validation: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			default: "",
		},
		labelTxt: {
			type: String,
			default: "Quill Editor",
		},
	},
	data() {
		return {
			toolbarOptions: {
				bold: true,
				italic: true,
				header: true,
				underline: true,
				strikethrough: true,
				mark: true,
				superscript: true,
				subscript: true,
				quote: true,
				ol: true,
				ul: true,
				link: false,
				imagelink: false,
				code: true,
				table: true,
				fullscreen: false,
				readmodel: true,
				htmlcode: false,
				help: false,
				/* 1.3.5 */
				undo: true,
				redo: true,
				trash: false,
				save: false,
				/* 1.4.2 */
				navigation: false,
				/* 2.1.8 */
				alignleft: true,
				aligncenter: true,
				alignright: true,
				/* 2.2.1 */
				subfield: true,
				preview: true,
			},
			content: this.value,
		};
	},
	methods: {
		onInput(content) {
			this.$emit("input", content);
		},
	},
	watch: {
		value(newVal) {
			this.content = newVal;
		},
	},
};
</script>

<style>
.custom-quill-editor .ql-editor {
	background-color: #fff !important;
	height: 200px !important;
	white-space: normal !important;
}

.custom-quill-editor .ql-toolbar.ql-snow {
	background: var(--blue-container-background);
}

.text-style {
	color: rgba(140, 140, 140, 1);
	font-size: 14px;
}
</style>
